import styled from 'styled-components';

export const SkeletonLoaderWrapper = styled.div`
    width: 100%;
    height: 18px;
    background: radial-gradient(
            70.94% 70.94% at 36.73% 29.06%,
            rgba(255, 255, 255, 0.05) 0%,
            rgba(255, 255, 255, 0) 100%
        ),
        rgba(255, 255, 255, 0.06);
    border-radius: 5px;
`;
export const InvisibleChildren = styled.div`
    visibility: hidden;
`;
